export const enum BreadcrumbType {
  SPORT = 'sport',
  UNION = 'union',
  TOURNAMENT = 'tournament',
  STAGE = 'stage',
}
